import React, { useEffect, useState, useCallback } from 'react';
import { Grid, Box, Paper, TableContainer, LinearProgress, Typography } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { Header } from "../../../components/global/Header";
import FormListToolbar from "../../../components/global/Toolbar";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useNavigate } from "react-router";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import SearchField from '../../../components/search/Search';
import { useProfitLoss } from './useProfitLoss';
import ErrorNotification from '../../../components/ErrorNotification/ErrorNotification';
import api from "../../../services/api";
import { useNotifier } from "muinotify";
import { exportToExcel } from '../../../components/export/exportToExcel';
import { exportToPdf } from '../../../components/export/exportToPdf';
import { exportToCsv } from '../../../components/export/exportToCsv';
// import CategoryItemForm from './CategoryItemForm';
// import ProductionCategoryItemDetails from './ProductionCategoryItemDetails';


const ProfitLoss = () => {
  const { notifier } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const { category_item, isLoading, error, mutate } = useProfitLoss(searchQuery);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedCategoryItem, setSelectedCategoryItem] = useState(null);

  const URL = `production-category-item`;
  const NAV_PATH = `category_item`;

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  function getRowId(row) {
    return row.id;
  }

  const handleClear = () => {
    setSearchQuery("");
    mutate(); // Refetch data after clearing search
  };

  let navigate = useNavigate();

  const handlePanelClose = () => {
    setSelectedCategoryItem(null);
  };

  const handleView = (category_item) => {
    setSelectedCategoryItem(category_item);
  };

  const handleEdit = (id) => {
    navigate(`/${NAV_PATH}/update/${id}`);
  };

  const handleAdd = () => {
    navigate(`/${NAV_PATH}/create/`);
  };

  const handleDelete = useCallback((id) => {
    confirmAlert({
      title: 'Confirm to delete',
      message: 'Are you sure you want to delete this category_item?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              await api.delete(`/${URL}/${id}`);
              notifier("Production deleted successfully.", { variant: "success" });
              await mutate();
            } catch (err) {
              notifier("Failed to delete production <Error: " + err.message + ">", { variant: "error" });
            }
          }
        },
        {
          label: 'No',
        }
      ]
    });
  }, [mutate, notifier]);


  const columnsToExtract = ['clientName', 'clientName', 'contactPerson', 'clientAddress', 'clientCity', 'clientPhone', 'clientEmail', 'clientNotes'];

  const handleExportToExcel = () => {
    exportToExcel(category_item || [], columns, columnsToExtract, 'clients-list', 'Clients List');
  };

  const handleExportToPdf = () => {
    exportToPdf(category_item || [], columns, columnsToExtract, 'clients-list');
  };

  const handleExportToCsv = () => {
    exportToCsv(category_item || [], columns, columnsToExtract, 'clients-list');
  };

  const columns = [
    {
      field: 'view',
      type: 'actions',
      width: 20,
      align: 'center',
      cellClassName: "actions",
      getActions: (params) => [
        <GridActionsCellItem color="primary" icon={<VisibilityOutlinedIcon />} label="View" onClick={() => handleView(params.row)} />,
      ],
    },
    {
      field: 'prod_descr', headerName: 'Production', flex: 0.5, renderCell: (params) => {
        return (
          <>
            <div>
              {params.value.p_descr}
            </div>
          </>
        );
      },
    },
    {
      field: 'prod_categ_descr', headerName: 'Production Category', flex: 1, renderCell: (params) => {
        return (
          <>
            <div>
              {params.value.pcit_descr}
            </div>
          </>
        );
      },
    },
    { field: 'pci_descr', headerName: 'Description', flex: 1 },
    // { field: 'pci_aa', headerName: 'AA', flex: 1 },
    // { field: 'pci_type', headerName: 'Type', flex: 1 },
    { field: 'pci_amount', headerName: 'Amount', flex: 1 },
    { field: 'pci_notes', headerName: 'Notes', flex: 1 },
    {
      field: 'actions',
      type: 'actions',
      width: 100,
      headerName: "Actions",
      getActions: (params) => [
        <GridActionsCellItem color="primary" icon={<EditOutlinedIcon />} label="Edit" onClick={() => handleEdit(params.row.id)} />,
        <GridActionsCellItem color="secondary" icon={<DeleteOutlineOutlinedIcon />} label="Delete" onClick={() => handleDelete(params.row.id)} />,
      ],
    },
  ];

  return (
    <Box m="20px" >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Category Items" module="Productions" subtitle="List of category items" />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={selectedCategoryItem ? 8 : 12}>

          <FormListToolbar
            handleAdd={handleAdd}
            handleExportToExcel={handleExportToExcel}
            handleExportToPdf={handleExportToPdf}
            handleExportToCsv={handleExportToCsv}
          />
          <Box
            m="8px 0 0 0"
            height="80vh"
          >
            {/* <Paper elevation={2} style={{ padding: '1rem', height: '100%', width: '100%' }}>
              <SearchField searchQuery={searchQuery} handleSearchChange={handleSearchChange} handleClear={handleClear} ml={2} mr={2} />
              {isLoading && <LinearProgress />}
              {error && <ErrorNotification ml={2} mr={2} error={error} />}
              <TableContainer style={{ height: '87%', width: '100%' }}>
                <DataGrid
                  rows={category_item || []}
                  columns={columns}
                  getRowId={getRowId}
                  columnVisibilityModel={{
                    id: false,
                  }}
                  onRowClick={(params) => setSelectedCategoryItem(params.row)} // Set selected client on row click
                  sx={{
                    '& .MuiDataGrid-root': {
                      border: 'none',
                    },
                    '& .MuiDataGrid-cell': {
                      borderBottom: '1px solid #e0e0e0',
                    },
                    '& .MuiDataGrid-columnsContainer': {
                      backgroundColor: '#f5f5f5',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: '#f5f5f5',
                      borderBottom: '1px solid #e0e0e0',
                    },
                    '& .MuiDataGrid-footerContainer': {
                      borderTop: '1px solid #e0e0e0',
                    },
                    '& .MuiTablePagination-root': {
                      color: '#000',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 'bold',
                    },
                    '& .MuiDataGrid-row:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '& .MuiDataGrid-cell:focus': {
                      outline: 'none',
                    },
                  }}
                />
              </TableContainer>
            </Paper> */}
          </Box>
        </Grid>
        {/* {selectedCategoryItem && (
          <Grid item xs={4}>
            <ProductionCategoryItemDetails
              category_item={selectedCategoryItem}
              onClose={handlePanelClose} />
          </Grid>
        )} */}
      </Grid>
    </Box>

  );
};

export default ProfitLoss;